export const requestPayment = (respService, respPlanArray, deviceFP) => {
    let response = respService
    let planArray = respPlanArray
    let deviceFingerprint = deviceFP

    // console.log('response:: ', response)
    // console.log('costo:: ', planArray)
    // console.log('DFP:: ', deviceFingerprint)
    
    let cantNombre = response?.tarjeta?.nombre.split(' ')
    let nombreComp = ""
    let apellidoP = ""
    let apellidoM = ""

    let datos_com = {
        '34': String(planArray?.searsInternet)
    }

    if(cantNombre.length >= 4){
        nombreComp = cantNombre[0]
        apellidoP = cantNombre[2]
        apellidoM = cantNombre[3]
    }
    else if(cantNombre.length === 3){
        nombreComp = cantNombre[0]
        apellidoP = cantNombre[1]
        apellidoM = cantNombre[2]
    }
    else if(cantNombre.length === 2){
        nombreComp = cantNombre[0]
        apellidoP = cantNombre[1]
        apellidoM = ""
    }
    else if(cantNombre.length === 1){
        nombreComp = cantNombre[0]
        apellidoP = ""
        apellidoM = ""
    }

    let cardEnding
    if(planArray?.dataAcount?.card){
        //cardEnding =  `***${planArray?.dataAcount?.card.substr(-4)}`
        cardEnding =  planArray?.dataAcount?.card
    }

    return {
        account_data: {
            number: planArray?.dataAcount?.account_number,
            card_number: cardEnding,
            terminal: Number(respPlanArray?.terminal),
            payment_plans: planArray?.planPagoGral
        },
        client_id: response?.tarjeta?.cliente_id,
        token_card: response?.tarjeta?.token,
        device_fingerprint: deviceFingerprint,
        datos_comercio: datos_com
    }
}